const imgUrl = [
  require('../../../assets/img/solutions/AI/AI (1).png'),
  require('../../../assets/img/solutions/AI/AI (2).png'),
  require('../../../assets/img/solutions/AI/AI (3).png'),
  require('../../../assets/img/solutions/AI/AI (4).png'),
  require('../../../assets/img/solutions/AI/AI (5).png'),
  require('../../../assets/img/solutions/AI/AI (6).png'),
  require('../../../assets/img/solutions/AI/AI (7).png'),
  require('../../../assets/img/solutions/AI/AI (8).png')
];

export default imgUrl;
